import React from "react";

import {
    Empty,
    Space
} from "antd";

import {
    useSelector
} from "react-redux";

import MessageBubble from "../message/MessageBubble";
import OfferCard from "../negotiation/OfferCard";
import CounterOfferCard from "../negotiation/CounterOfferCard";
import AgreementCard from "../negotiation/AgreementCard";
import SystemMessage from "../message/SystemMessage";

const ConversationMessages = () => {

    const messages = useSelector(
        state =>
            state.conversationNotification?.messages || []
    );

    console.log("The messages in ConversationDrawer", messages)

    if (messages.length === 0) {
        return (
            <Empty
                description="Aucun message"
            />
        );
    }

    return (
        <div
            style={{
                padding: 20,
                maxHeight: "58vh",
                overflowY: "auto",
                background: "#fafafa"
            }}
        >
            <Space
                direction="vertical"
                size={18}
                style={{
                    width: "100%"
                }}
            >
                {messages.map(message => {

                    if (
                        message.senderType === "SYSTEM"
                    ) {
                        switch (message.messageType) {

                            case "SELLER_OFFER":
                                return (
                                    <OfferCard
                                        key={message.id}
                                        offer={message}
                                    />
                                );

                            case "COUNTER_OFFER":
                                return (
                                    <CounterOfferCard
                                        key={message.id}
                                        offer={message}
                                    />
                                );

                            case "AGREEMENT":
                                return (
                                    <AgreementCard
                                        key={message.id}
                                        agreement={message}
                                    />
                                );

                            default:
                                return (
                                    <SystemMessage
                                        key={message.id}
                                        message={message}
                                    />
                                );
                        }
                    }

                    return (
                        <MessageBubble
                            key={message.id}
                            message={message}
                        />
                    );
                })}
            </Space>
        </div>
    );
};

export default ConversationMessages;